import { DESCRIPTION_HTML_ALLOWED_TAGS, isDescriptionHtml } from '@nudool/shared';
import DOMPurify from 'dompurify';
import * as React from 'react';

import { cn } from './lib/utils.js';

const RICH_TEXT_CLASS =
  'break-words [&_b]:font-semibold [&_li>p]:mt-0 [&_p+p]:mt-2 [&_p+ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul+p]:mt-2';

export function DimeRichText({
  value,
  className,
}: Readonly<{ value: string; className?: string }>) {
  const html = React.useMemo(
    () =>
      isDescriptionHtml(value)
        ? DOMPurify.sanitize(value, {
            ALLOWED_TAGS: [...DESCRIPTION_HTML_ALLOWED_TAGS],
            ALLOWED_ATTR: [],
            ALLOW_ARIA_ATTR: false,
            ALLOW_DATA_ATTR: false,
          })
        : null,
    [value],
  );

  if (html === null) {
    return (
      <div data-slot="rich-text" className={cn('break-words whitespace-pre-line', className)}>
        {value}
      </div>
    );
  }

  return (
    <div
      data-slot="rich-text"
      className={cn(RICH_TEXT_CLASS, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
